"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
class WhatsNew extends base_1.default {
    getLatestWhatsNew() {
        return this.post('/whats-new/latest-whats-new');
    }
    addUserWhatsNew(data) {
        return this.post('/whats-new/add-user-whats-new', data);
    }
}
exports.default = new WhatsNew();
